import React, { createContext, useContext, useState, ReactNode } from 'react'
import { ImageValue, ImageParsedValue } from './withJSSContext'

type StoredImageSharedValue = {
  id: string
  currentSlide: number
  description: string
}

export type StoredImageValue = ImageValue & StoredImageSharedValue

export type StoredImageParsedValue = ImageParsedValue & StoredImageSharedValue

export type StoredImage = StoredImageValue | StoredImageParsedValue

type setStoreImage = (instance: number, firstImage: StoredImage, secondImage?: StoredImage) => void

interface ImageData {
  image: StoredImage
  instance: number
}

interface ImageStoreContextValue {
  sharedStoreImages: StoredImage[]
  setStoreImage?: setStoreImage
}

const ImageStoreContext = createContext<ImageStoreContextValue>({ sharedStoreImages: [] })

export const useImageStore = (): ImageStoreContextValue => {
  return useContext(ImageStoreContext)
}

interface Props {
  children: ReactNode
}

export const ImageStoreProvider: React.FC<Props> = ({ children }) => {
  const [sharedStoreImages, setSharedStoreImages] = useState<ImageData[]>([])

  const setStoreImage: setStoreImage = (instance, firstImage, secondImage): void => {
    const nextImages: ImageData[] = [
      { instance: instance, image: firstImage },
      ...(secondImage ? [{ instance: instance, image: secondImage }] : []),
    ]

    setSharedStoreImages((prevState) => [...prevState, ...nextImages]?.sort((a, b) => a.instance - b.instance))
  }

  const contextValue: ImageStoreContextValue = {
    sharedStoreImages: sharedStoreImages?.map((item, index) => ({ ...item.image, currentSlide: index })),
    setStoreImage,
  }

  return <ImageStoreContext.Provider value={contextValue}>{children}</ImageStoreContext.Provider>
}
